import { useMutation, useQuery } from 'react-query'
import { message } from 'antd'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import {
  editOptionsThemeColors,
  getOptionsDueReminders,
  getPropertyOptions,
  isLockDateDeletable,
  updateOptions,
  updateOptionsDueReminders,
} from 'utils/apis'
import { editOptionsRedux } from 'app-redux/options/actions'
import { optionsSelector } from 'app-redux/selectors'

export const useOptionsDueReminders = ({ payload, options = {} } = {}) => {
  return useQuery(
    ['getOptionsDueReminders', payload],
    async () => {
      const {
        data: { data },
      } = await getOptionsDueReminders(payload)
      return data
    },
    {
      ...options,
      keepPreviousData: true,
      onError: (error) => message.error((error && error.message) || 'Failed data from server!'),
    },
  )
}

export const useOptionsDueRemindersMutation = ({ options = {} } = {}) => {
  return useMutation((payload) => updateOptionsDueReminders(payload), {
    ...options,
  })
}

export const useEditOptions = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const prevOptions = useSelector(optionsSelector)
  return useMutation(({ apiOptions, ...payload }) => updateOptions(payload, apiOptions), {
    onMutate: ({ apiOptions, ...payload }) => {
      dispatch(editOptionsRedux(payload))
      return { prevOptions }
    },
    onSuccess: ({ data }, val, context) => {
      if (data?.success) {
        message.success(data?.message)
      } else {
        // Server menolak perubahan: kembalikan nilai lama supaya UI tidak menampilkan state palsu
        dispatch(editOptionsRedux(context.prevOptions))
        message.error(data?.message || formatMessage({ id: 'settings.failed_to_save' }))
      }
    },
    onError: (error, val, context) => {
      dispatch(editOptionsRedux(context.prevOptions))
      message.error(error?.data?.message || formatMessage({ id: 'settings.failed_to_save' }))
    },
  })
}

export const useEditOptionThemeColors = () => {
  return useMutation((payload) => editOptionsThemeColors(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message)
      } else {
        message.success(data?.message)
      }
    },
    onError: (error) => {
      message.error((error && error.message) || 'Failed save data to server!')
    },
  })
}

export const useOptions = (options = {}) => {
  return useQuery(
    ['options'],
    async () => {
      const {
        data: { data },
      } = await getPropertyOptions()
      return data
    },
    {
      ...options,
      onError: (error) => message.error((error && error.message) || 'Failed data from server!'),
    },
  )
}

export const useIsLockDateDeletable = (options = {}) => {
  return useQuery(
    ['lock-date-deletable'],
    async () => {
      const { data } = await isLockDateDeletable()
      return data
    },
    {
      onError: (error) => message.error(error?.data?.message || 'Failed from server!'),
      ...options,
    },
  )
}
